import { forwardRef, useState } from "react";
import { Indicator, Root } from "@radix-ui/react-checkbox";
import { cn } from "@/utils";
import { CheckboxIcon } from "@/icons";

interface CheckboxProps {
  defaultChecked?: boolean;
  checked?: boolean;
  disabled?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  className?: string;
  dataTestId?: string;
  name?: string;
  id?: string;
}

export const CheckboxInput = forwardRef<HTMLButtonElement, CheckboxProps>(
  (
    {
      defaultChecked,
      checked,
      disabled,
      onCheckedChange,
      className,
      dataTestId,
      name,
      id,
    }: CheckboxProps,
    ref,
  ) => {
    const [checkedDefault, setCheckedDefault] = useState<boolean>(
      defaultChecked ?? false,
    );

    return (
      <Root
        ref={ref}
        defaultChecked={defaultChecked}
        checked={checked ?? checkedDefault}
        disabled={disabled}
        onCheckedChange={onCheckedChange ?? setCheckedDefault}
        className={cn(
          "border-item-secondary text-item-invert-primary flex h-4 w-4 items-center justify-center rounded-[4px] border-2 hover:border-highlightPrimary",
          "data-[state=checked]:border-none data-[state=checked]:bg-highlightPrimary data-[state=checked]:hover:bg-highlightSecondary",
          disabled &&
            "!border-item-tertiary text-item-tertiary !bg-surface-tertiary cursor-not-allowed !border-solid",
          className,
        )}
        data-testid={dataTestId}
        id={id}
      >
        <Indicator>
          <CheckboxIcon />
        </Indicator>
        {/* Hidden input field to submit checkbox value */}
        <input
          type="hidden"
          name={name}
          value={checked?.toString() ?? checkedDefault?.toString()}
        />
      </Root>
    );
  },
);

CheckboxInput.displayName = "CheckboxInput";
